export default {
  'meta': {
    'langName': 'CROATIAN',
    'lang': 'Hrvatski'
  },
  'title': 'POVLAČENJE PROIZVODA BASKETBALL HOOP B900 BOX NBA TARMAK',
  'description': 'Pozdrav!\n\nNedavno ste kupili košarkaški koš Tarmak B900 BOX NBA i zahvaljujemo Vam na kupnji.\n\nKao dio naše trajne predanosti kvaliteti i sigurnosti proizvoda, košarkaški tim DECATHLONA uočio je potencijalni rizik od vertikalnog pada štapa ako se ukloni ručica za podešavanje visine, a proizvodom se zatim rukuje ili ga se koristi.\n\nLjubazno Vas molimo da odgovorite na nekoliko pitanja, kako bismo Vam mogli pružiti odgovarajuće sigurnosno rješenje za vaš proizvod.\n\nIspričavamo se zbog neugodnosti i zahvaljujemo Vam na ukazanom povjerenju.\n\nDECATHLON',
  'emailConfirmation': {
    'title': 'Prvo, molimo Vas da potvrdite svoju adresu e-pošte i državu prebivališta:'
  },
  'fields': {
    'country': 'Država',
    'address': 'E-pošta',
    'email': 'E-pošta',
    'phonePrefix': 'Pozivni broj',
    'phone': 'Telefonski broj',
    'validations': {
      'phoneOrEmail': 'Molimo navedite barem adresu e-pošte ili broj telefona.',
      'email': 'Molimo, unesite važeću adresu',
      'phone': 'Molimo, unesite važeći broj telefona'
    },
    'firstName': 'Prezime',
    'lastName': 'Ime',
    'deliveryAddress': 'Adresa za dostavu paketa',
    'additionalAddress': 'Dodatne pojedinosti o adresi',
    'city': 'Grad',
    'zip': 'Poštanski broj',
    'choose': 'Odaberi',
    'required': 'Ovo polje je obavezno'
  },
  'ownerCheck': {
    'title': 'Posjedujete li još uvijek jedan ili više košarkaških koševa B900 BOX NBA?'
  },
  'yes': 'DA',
  'no': 'NE',
  'ownerChanged': {
    'title': 'Imate li kontakt podatke trenutnog vlasnika?',
    'confirmation': 'Poštovani,\n\nHvala Vam na sudjelovanju u ovoj inicijativi.\n\nIspričavamo se zbog neugodnosti i zahvaljujemo Vam na ukazanom povjerenju.\n\nDECATHLON'
  },
  'recall': {
    'title': 'Molimo navedite broj košarkaških koševa koje imate, ovisno o vrsti ugrađene ručice.',
    'descriptionRed': 'Košarkaški koš s uklonjivom crvenom ručicom',
    'descriptionBlack': 'Košarkaški koš s fiksnom crnom ručicom',
    'quantity': 'Količina',
    'notConcerned': 'Poštovani,\n\nHvala Vam što sudjelujete u ovoj inicijativi.\n\nMožete biti sigurni da Vaš košarkaški koš Tarmak B900 BOX NBA nije pogođen postupkom opoziva. Siguran je za korištenje.\n\nIspričavamo se zbog eventualnih neugodnosti i zahvaljujemo Vam na ukazanom povjerenju.\n\nDECATHLON',
    'concernedProductQuantity': 'Količina neusklađenih proizvoda:',
    'concernedProductLabel': 'Neusklađen proizvod:',
    'confirmation': 'Hvala Vam što ste ispunili ovaj obrazac. Vaš je zahtjev uspješno zabilježen.\n\nPoslat ćemo Vam broj za praćenje Vaše pošiljke u najkraćem mogućem roku (putem FandiWeba).\n\nŽelimo Vam ugodan dan.\n\nDECATHLON'
  },
  'repair': {
    'title': 'Popravak uz Vaše sudjelovanje',
    'description': 'Otkrili smo rizik od vertikalnog pada štapa ako se ručica ukloni, a proizvodom se rukuje ili ga se koristi, na određenim košarkaškim koševima TARMAK B900 BOX NBA, br. artikla 4239136.\nNa temelju Vašeg odgovora, čini se da je Vaš proizvod pogođen ovim rizikom.\n\nStoga Vas molimo da ga odmah prestanete koristiti i nudimo Vam pomoć u prilagodbi ručice, kako biste mogli sigurno koristiti svoj proizvod.\nBudite uvjereni, ovaj popravak ne zahtijeva posebnu stručnost - sve je jasno objašnjeno u videu i uputama za uporabu u nastavku:\n',
    'videoLink': 'Poveznica na video',
    'docLink': 'Poveznica na tekst',
    'callToAction': 'Kliknite ovdje kako biste dobili svoj besplatni komplet za popravak',
    'warranty': 'Cijeli proces pokriven je našim 5-godišnjim jamstvom.'
  },
  'repairRequest': {
    'title': 'Molimo, unesite sljedeće podatke, kako bismo Vam besplatni komplet poslali na adresu po Vašem izboru:'
  },
  'form': {
    'submit': 'Sljedeće'
  },
  'status': 'Translation validated by COUNTRY'
} as const
